import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { NAME, TIME_ZONE, UNIQUE_IDENTIFIER, SHARD_COUNT } from '../constants';
import { UniqueIdentifierValues } from '../types';

const schema = z.object({
  [NAME]: z.string().min(1, 'Name must be present.'),
  [TIME_ZONE]: z.string(),
  [UNIQUE_IDENTIFIER]: z.nativeEnum(UniqueIdentifierValues),
  [SHARD_COUNT]: z.number().nullable(),
});

const createDefaultValues = (EmailProjectTypePhaseout = false) =>
  EmailProjectTypePhaseout
    ? {
        [NAME]: '',
        [TIME_ZONE]: 'America/Los_Angeles',
        [UNIQUE_IDENTIFIER]: UniqueIdentifierValues.emailOrUserId,
        [SHARD_COUNT]: null,
      }
    : {
        [NAME]: '',
        [TIME_ZONE]: 'America/Los_Angeles',
        [UNIQUE_IDENTIFIER]: UniqueIdentifierValues.email,
        [SHARD_COUNT]: null,
      };

export type NewProjectFormSchema = Required<z.infer<typeof schema>>;

export const NewProjectFormProvider = ({
  children,
  EmailProjectTypePhaseout,
}: {
  children: React.ReactNode;
  EmailProjectTypePhaseout?: boolean;
}) => {
  const defaultValues = createDefaultValues(EmailProjectTypePhaseout);
  const methods = useForm<NewProjectFormSchema>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
